import CombatMobile from "./CombatMobile";

export default CombatMobile;
export { CombatMobile };
